export default __webpack_public_path__ + "static/media/doc.89f8c4ab.svg";